export default __webpack_public_path__ + "static/media/ddf-grafik_03.d307791b.png";